import { useCallback, useState } from "react";
import { useSelector } from "react-redux";

import { dispatch } from "../../state/store";
import { setUsersRefresh } from "../../state/ducks";

import { routePaths, strCode } from "../../consts";
import {
  adminUserService,
  log,
  navigationService,
  notificationService,
  t,
  usersService
} from "../../services";
import { adminUserUtils, responseUtil, userUtil } from "../../utils";
import { selectUserMarkets } from "../../state/selectors";

export const useDeleteUser = () => {
  const adminMarkets = useSelector(selectUserMarkets());
  const [loading, setLoading] = useState();

  const mutationCallback = useCallback(
    async (user, isAdminUser, onSaveCallback) => {
      setLoading(true);

      const hasAdminAppType = adminUserUtils.isUserAdmin(user);

      let updatedGroups = user.groups;
      let hasUneditableMarkets = false;

      // check if user has market that cannot be deleted
      if (!hasAdminAppType) {
        updatedGroups = user.groups.map((group) => {
          return { ...group, markets: group?.markets.filter((m) => !adminMarkets.includes(m)) };
        });

        hasUneditableMarkets = updatedGroups.findIndex((group) => group.markets?.length) !== -1;
      }

      if (hasUneditableMarkets && !hasAdminAppType) {
        // if yes -> remove admin markets from the user and save changes
        user.groups = updatedGroups?.filter((group) => group.markets?.length);

        try {
          await onSaveCallback(userUtil.prepareUserData(user, isAdminUser), user?.groupAssignments);
        } catch (e) {
          log.error(`useUpdateGroups: An error occurred while saving users data.`, e);
        } finally {
          setLoading(false);
        }
      } else {
        // if no -> delete user
        try {
          const res = isAdminUser
            ? await adminUserService.deleteAdminUser(user)
            : await usersService.deleteUser(user);

          if (responseUtil.isResponseSuccessful(res)) {
            notificationService.showSuccess({
              title: t(strCode.DELETE_USER_SUCCESS),
              message: t(strCode.DELETE_USER_SUCCESS_INFO)
            });

            dispatch(setUsersRefresh(true));
            navigationService.replace(routePaths.USERS);
          }
        } catch (err) {
          log.error("useUpdateGroups: Failed to delete user", err);

          notificationService.showError({
            title: t(strCode.DELETE_USER_ERROR),
            message: err?.response?.data?.message ? err.response.data.message : err?.toString()
          });
        } finally {
          setLoading(false);
        }
      }
    },
    [adminMarkets]
  );

  return { mutationCallback, loading };
};
